<template>
    <div>
        <h3>Your Profile</h3>
        <hr>
        <b-form>
            <b-form-group label-cols="3" label-align="right">
                <template #label for="name">
                    {{ 'Name' }}
                </template>
                <b-form-input :value="name"
                              plaintext
                              type="text"
                              name="name"
                />
            </b-form-group>
            <b-form-group label-cols="3" label-align="right">
                <template #label for="email">
                    {{ 'Email' }}
                </template>
                <b-form-input :value="userInfo.email"
                              plaintext
                              type="text"
                              name="email"
                />
            </b-form-group>
            <b-form-group label-cols="3" label-align="right">
                <template #label for="phone">
                    {{ 'Phone' }}
                </template>
                <b-form-input :value="userInfo.phone"
                              plaintext
                              type="text"
                              name="phone"
                />
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return { };
    },
    computed: {
        ...mapGetters({
            userInfo: 'auth/authUser',
        }),
        name() {
            return this.userInfo.fname + ' ' + this.userInfo.lname;
        },
    },

    methods: {},
};
</script>
